<template>
  <div class="subscription-interval-selector">
    <label class="subscription-interval-selector-label">{{ translations.deliverEveryText }}</label>
    <select type="select" class="subscription-interval-selector-input" @change="onChange($event)">
      <option v-for="frequency in shippingIntervalFrequency" :value="frequency">{{ frequency }} {{ shippingIntervalUnitType | pluralize(parseInt(frequency)) }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionIntervalSelector',

  model: {
    prop: 'deliveryInterval',
    event: 'change'
  },
  props: {
    deliveryInterval: {
      type: String,
      required: true
    },
    shippingIntervalFrequency: {
      type: Array,
      required: true
    },
    shippingIntervalUnitType: {
      type: String
    },
    translations: {
      type: Object,
      required: true
    }
  },

  methods: {
    onChange(event) {
      let value = event.target.value;
      if (this.selected !== value) {
        this.$emit('deliveryIntervalUpdateEmit', value);
      }
    }
  }
};
</script>
